import {
  ConversationChannelContentTypeMap,
  MetaConversation,
} from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { PHONE_BASED_CHANNELS, TEXT_BASED_CHANNELS } from 'app/utils/channels';

export const isConversationTextBased = (
  channel: keyof ConversationChannelContentTypeMap,
): boolean => {
  return TEXT_BASED_CHANNELS.includes(channel);
};

export const isConversationPhoneCall = (
  channel: keyof ConversationChannelContentTypeMap,
): boolean => {
  return PHONE_BASED_CHANNELS.includes(channel);
};

export const isAbandonedConversation = (
  metaConversation: MetaConversation,
): boolean => {
  return !!metaConversation.conversation.is_abandoned;
};

export const isEndUserConnected = (
  metaConversation: MetaConversation,
): boolean => {
  return !!metaConversation.conversation.live_assesment?.is_end_user_connected;
};

export const isCallbackConsumed = (
  metaConversation: MetaConversation,
): boolean => {
  return !!metaConversation.conversation.is_callback_consumed;
};

export const getRequesterWithDisplayName = (
  requester: User | undefined,
): User | undefined => {
  return requester
    ? {
        ...requester,
        ...(requester.name != null && typeof requester.name === 'string'
          ? { display_name: requester.name }
          : {}),
      }
    : undefined;
};

export const shouldShowTranscript = (
  channel: keyof ConversationChannelContentTypeMap,
): boolean => {
  return ['email', 'widgetchat', 'contactform'].includes(channel);
};
